import { render, staticRenderFns } from "./ProfileUserMenuEntry.vue?vue&type=template&id=34b2b979&scoped=true"
import script from "./ProfileUserMenuEntry.vue?vue&type=script&lang=js"
export * from "./ProfileUserMenuEntry.vue?vue&type=script&lang=js"
import style0 from "./ProfileUserMenuEntry.vue?vue&type=style&index=0&id=34b2b979&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b2b979",
  null
  
)

export default component.exports